/** Callback requests have no appointment time: show when they were requested instead. */
export const isCallbackFromLocation = (serviceRequest?: { service?: { key?: string } } | null) =>
  serviceRequest?.service?.key === 'callbackFromLocation';

export const getServiceRequestDisplayDate = <T extends { service?: { key?: string }; created?: string; utc_start_time?: string }>(
  serviceRequest: T,
) => (isCallbackFromLocation(serviceRequest) ? serviceRequest.created : serviceRequest.utc_start_time);
